// ── CMS Non-Monetary Compensation limits ──────────────────────────────────────
// Keep in sync with stark.service.js on the backend.
//
// Sources:
//   2024 — 89 FR 1350   ($507 annual / $42 per-occurrence)
//   2025 — 89 FR 73472  ($519 annual / $43 per-occurrence)
//   2026 — CMS CY2026   ($535 annual / $46 per-occurrence)
export const CMS_LIMITS = {
  2024: { annual: 507.00, per_occurrence: 42.00 },
  2025: { annual: 519.00, per_occurrence: 43.00 },
  2026: { annual: 535.00, per_occurrence: 46.00 },
};

/**
 * Return the CMS annual limit for a given year.
 * Falls back to the most recent known year if the year is not configured.
 */
export const getCmsAnnualLimit = (year) => {
  if (CMS_LIMITS[year]) return CMS_LIMITS[year].annual;
  const years = Object.keys(CMS_LIMITS).map(Number);
  return CMS_LIMITS[Math.max(...years)].annual;
};

export const getCmsPerOccurrenceLimit = (year) => {
  if (CMS_LIMITS[year]) return CMS_LIMITS[year].per_occurrence;
  const years = Object.keys(CMS_LIMITS).map(Number);
  return CMS_LIMITS[Math.max(...years)].per_occurrence;
};

// ── Category constants ─────────────────────────────────────────────────────────
export const STARK_CATEGORIES = [
  { value: 1, label: 'Meal' },
  { value: 2, label: 'Gift' },
  { value: 3, label: 'Entertainment' },
  { value: 4, label: 'CME/Educational' },
  { value: 5, label: 'Other' },
];

export const STARK_CATEGORY_MAP = STARK_CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label;
  return acc;
}, {});

// ── Status thresholds ──────────────────────────────────────────────────────────
// These match the backend logic in stark.service.js _buildLimitWarnings.
export const STARK_STATUS = {
  OK:       'ok',
  WARNING:  'warning',   // >= 80% of annual limit
  EXCEEDED: 'exceeded',  // >= 100% of annual limit
};

/**
 * Compute a provider's status given their YTD total and the annual limit.
 */
export const getStarkStatus = (ytdTotal, annualLimit) => {
  if (ytdTotal >= annualLimit) return STARK_STATUS.EXCEEDED;
  const pct = annualLimit > 0 ? (ytdTotal / annualLimit) * 100 : 0;
  if (pct >= 80) return STARK_STATUS.WARNING;
  return STARK_STATUS.OK;
};

/**
 * Return true when a Stark entry for the given spending year is past its
 * 30-day edit window (Jan 30 of the following year).
 */
export const isStarkEntryLocked = (spendingDate) => {
  const year     = new Date(spendingDate).getFullYear();
  const lockDate = new Date(year + 1, 0, 30); // Jan 30, year+1
  return new Date() > lockDate;
};
